// extracted by mini-css-extract-plugin
export default {"container":"ExactMatchToggle-module__container__j84Lt"};